var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowUpRight = function SvgArrowUpRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V9.414l-8.293 8.293a1 1 0 0 1-1.414-1.414L14.586 8H7Z",
    fill: "currentColor"
  })));
};

export { SvgArrowUpRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyA4QzYuNDQ3NzIgOCA2IDcuNTUyMjggNiA3QzYgNi40NDc3MiA2LjQ0NzcyIDYgNyA2SDE3QzE3LjU1MjMgNiAxOCA2LjQ0NzcyIDE4IDdWMTdDMTggMTcuNTUyMyAxNy41NTIzIDE4IDE3IDE4QzE2LjQ0NzcgMTggMTYgMTcuNTUyMyAxNiAxN1Y5LjQxNDIxTDcuNzA3MTEgMTcuNzA3MUM3LjMxNjU4IDE4LjA5NzYgNi42ODM0MiAxOC4wOTc2IDYuMjkyODkgMTcuNzA3MUM1LjkwMjM3IDE3LjMxNjYgNS45MDIzNyAxNi42ODM0IDYuMjkyODkgMTYuMjkyOUwxNC41ODU4IDhIN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";